import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import TechPage from './pages/TechPage';
import KnowHowPage from './pages/KnowHowPage';
import ClanekPage from './pages/ClanekPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import NotFound from './pages/NotFound';
import ThankYouPage from './pages/ThankYouPage';
import SrovnavacPage from './pages/SrovnavacPage';
import Srovnavac2Page from './pages/Srovnavac2Page';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white selection:bg-blue-600 selection:text-white font-sans antialiased flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produkty" element={<Navigate to="/produkty/ledbary" replace />} />
            <Route path="/produkty/:kategorie/:slug" element={<ProductPage />} />
            <Route path="/produkty/:kategorie" element={<CategoryPage />} />
            <Route path="/technologie" element={<TechPage />} />
            <Route path="/know-how" element={<KnowHowPage />} />
            <Route path="/know-how/:slug" element={<ClanekPage />} />
            <Route path="/o-nas" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/dekujeme" element={<ThankYouPage />} />
            <Route path="/srovnavac" element={<Srovnavac2Page />} />
            <Route path="/srovnavac-2" element={<Navigate to="/srovnavac" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;